import { Dispatch } from "redux";
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";
import format from "date-fns/format";
import { resources } from "@constants/hardcoded-strings";
import { SERVER_DATE_FORMAT } from "@constants/date-formats";
import {
    setUserSummarySearchResults,
    setUserSummarySearchResultsLoading
} from "@redux/actions/user-summary-actions";
import { getMonthlyUsersRequest } from "@requests/reports/get-monthly-users";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { generateQueryParameters } from "@utils/query-parameter-util";

export const getUserSummaryResultsReduxRequest = (dispatch: Dispatch) => async (
    companyId: string,
    rpServiceId: string,
    workflowId: string,
    startDate: Date,
    endDate: Date
) => {
    dispatch(setUserSummarySearchResultsLoading(true));

    const queryParameters = generateQueryParameters({
        rpAXNServiceID: rpServiceId,
        companyID: companyId,
        workflowID: workflowId,
        startDate: format(startOfDay(startDate), SERVER_DATE_FORMAT),
        endDate: format(endOfDay(endDate), SERVER_DATE_FORMAT),
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        dateFormat: SERVER_DATE_FORMAT
    });

    const { data, error } = await getMonthlyUsersRequest(queryParameters);

    if (data) {
        dispatch(setUserSummarySearchResults(data));
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getMonthlyUsers.error.title,
                resources.requests.getMonthlyUsers.error.message
            );
        }
        dispatch(setUserSummarySearchResultsLoading(false));
    }
};